import type { ComponentPropsWithoutRef } from "react";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { CanvasToolsPositionsProvider } from "../CanvasToolsPositionsContext";
import { useNonIframeCanvasToolsPositions } from "./useNonIframeCanvasToolsPositions";
import { useNonIframeResizeListeners } from "./useNonIframeResizeListeners";

export interface CanvasToolsProps extends ComponentPropsWithoutRef<"div"> {}

export const NonIframeCanvasTools = ({ children }: CanvasToolsProps) => {
  const { selectedBlock, positions, updatePosition } =
    useNonIframeCanvasToolsPositions();
  useNonIframeResizeListeners({ updatePosition });

  const canvasCardRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    canvasCardRef.current = document.getElementById("builder-ui-canvas-card");
  }, []);

  if (!selectedBlock || !positions || !canvasCardRef.current) {
    return null;
  }

  const toolsElement = (
    <CanvasToolsPositionsProvider positions={positions}>
      <div
        className="border-circle pointer-events-none absolute z-10 border-2"
        data-testid="builder-ui-canvas-tools"
        style={{
          top: positions.elementRect.top,
          left: positions.elementRect.left,
          width: positions.elementRect.width,
          height: positions.elementRect.height,
        }}
      >
        {children}
      </div>
    </CanvasToolsPositionsProvider>
  );

  if (!canvasCardRef.current) {
    return toolsElement;
  }

  return createPortal(toolsElement, canvasCardRef.current);
};
